import { apiUrl, authHeaders } from "./auth";

export const fetchchangerequest = async (page: number, sort: string, sort_by: string, status?: string) => {
    const headers = authHeaders();
    let url = apiUrl + `/admin/vendor-change-requests?page=${page}&sort=${sort}&sort_by=${sort_by}`;
    if (status) {
        url += `&status=${status}`;
    }

    const resp = await fetch(url, {
        method: 'GET',
        headers,
    });
    if (!resp.ok) {
        throw new Error(`Error fetching change request`);
    }
    const json = await resp.json();
    return json;
}

export const fetchChangeRequestStatusCounts = async () => {
    const headers = authHeaders();
    const url = apiUrl + `/admin/vendor-change-requests/status-counts`;

    const resp = await fetch(url, {
        method: 'GET',
        headers,
    });
    if (!resp.ok) {
        throw new Error(`Error fetching change request status counts`);
    }
    const json = await resp.json();
    return json;
}